import { useTranslation } from 'react-i18next';

export const useEventJournal = () => {
    const { t } = useTranslation();
    return { t };
};
